import Grid from 'components/core/Grid';
import AddressDropdownSelect from 'components/formik/core/FormikAddressAutocomplete/components/AddressDropdownSelect';
import FieldInput from './FieldInput';
import styled from 'styled-components';

export const InputFieldGrid = styled(Grid)`
  & .MuiInputLabel-root {
    position: absolute !important;
  }
`;


interface Props {
  formikPrefix: string;
  disabled?: boolean;
  COUNTRIES: any;
  selectedCountry: any;
  handleCountrySelect: (e: any, newValue: any) => void;
  filteredRegions: any;
  selectedRegion: any;
  handleRegionSelect: any;
}

export const AddressFields = ({
  formikPrefix,
  disabled = false,
  COUNTRIES,
  selectedCountry,
  handleCountrySelect,
  filteredRegions,
  selectedRegion,
  handleRegionSelect,
}: Props) => {
  return (
    <InputFieldGrid item xs={12}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FieldInput name={`${formikPrefix}ADDRESS.UNIT`} label="Unit #" disabled={disabled} />
        </Grid>
        <Grid item xs={12}>
          <FieldInput
            name={`${formikPrefix}ADDRESS.STREET_NUMBER`}
            label="Street Number"
            id="streetNumeber"
            disabled={disabled}
          />
        </Grid>
        <Grid item xs={12}>
          <FieldInput name={`${formikPrefix}ADDRESS.STREET_NAME`} label="Street Name" disabled={disabled} />
        </Grid>

        <Grid item xs={12} sm={6}>
          <FieldInput name={`${formikPrefix}ADDRESS.CITY`} label="City" disabled={disabled} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <AddressDropdownSelect
            options={COUNTRIES}
            value={selectedCountry}
            handleSelect={handleCountrySelect}
            label="Country"
            name={`${formikPrefix}ADDRESS.COUNTRY`}
            disabled={disabled || COUNTRIES.length === 0}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <AddressDropdownSelect
            options={filteredRegions}
            value={selectedRegion}
            handleSelect={handleRegionSelect}
            label="Province/State"
            name={`${formikPrefix}ADDRESS.REGION`}
            disabled={disabled || filteredRegions.length === 0}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <FieldInput name={`${formikPrefix}ADDRESS.POSTAL`} label="Zip/Postal Code" disabled={disabled} />
        </Grid>
      </Grid>
    </InputFieldGrid>
  );
};
